module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular--70479481cd786114774c92e8d04a4028.70479481cd786114774c92e8d04a4028.woff";